import React from 'react';
import content from '../../assets/imgs/mobModalC.png';

const CdnMobContents = ({ isOpen, onClose, children }) => {
  return (
    <div className={'flex-col'}>
      <div style={{ padding: '0 16px' }}>
        <span
          style={{
            color: '#232323',
            fontFamily: '"Pretendard Variable"',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '140%',
            letterSpacing: '-0.42px',
          }}
        >
          PC에 있는 소용량 혹은 대용량 동영상을 언제 어디서나
          웹/스마트폰/태블릿PC/스마트TV등으로 시청 가능합니다.
        </span>
      </div>
      <img style={{ width: '100%' }} src={content} alt="" />
    </div>
  );
};

CdnMobContents.headerTitle = 'MOBILE VOD SERVICE';

export default CdnMobContents;
